import http from "@/utils/request"
import { ID, PaginationResult } from "@/types/common"
import { FileAsset, FileAssetFormData } from "../types"

const BASE_PATH = "/file-assets"

const fileAssetApi = {
  async getList(params?: {
    page?: number
    pageSize?: number
    keyword?: string
  }): Promise<PaginationResult<FileAsset>> {
    const res = await http.get<PaginationResult<FileAsset>>(BASE_PATH, { params })
    return res.data
  },

  async getById(id: ID): Promise<FileAsset | null> {
    const res = await http.get<FileAsset>(`${BASE_PATH}/${id}`)
    return res.data
  },

  async create(data: FileAssetFormData): Promise<void> {
    const formData = new FormData()
    if (data.file) {
      formData.append("file", data.file)
    }
    formData.append("name", data.name)
    if (data.note) {
      formData.append("note", data.note)
    }

    await http.post(BASE_PATH, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  async update(id: ID, data: FileAssetFormData): Promise<void> {
    await http.put(`${BASE_PATH}/${id}`, {
      name: data.name,
      note: data.note,
    })
  },

  async delete(ids: ID[]): Promise<void> {
    await http.post(`${BASE_PATH}/batch-delete`, { ids })
  },

  async download(item: FileAsset): Promise<void> {
    const res = await http.get<Blob>(`${BASE_PATH}/${item.id}/download`, {
      responseType: "blob",
    })
    const blob = res.data as Blob
    const url = window.URL.createObjectURL(blob)
    const anchor = document.createElement("a")
    anchor.href = url
    anchor.download = item.originalName
    anchor.click()
    window.URL.revokeObjectURL(url)
  },
}

export default fileAssetApi
